import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

import { createPurchaseBodyArgs } from '@/components/purchase/PaymentElementsForm/utils';
import { useFreeTrial } from '@/hooks/purchase/useFreeTrial';
import { usePricesState, usePurchaseParamsState, useUserState } from '@/hooks/store';

export type UseLegacyPlanDetailsProps = {
	hasTrueMedSupport?: boolean;
	purchaseArgs?: Record<string, unknown>;
};

export default function usePurchaseBodyArgs({ hasTrueMedSupport, purchaseArgs }: UseLegacyPlanDetailsProps) {
	const purchaseParams = usePurchaseParamsState();
	const prices = usePricesState();
	const user = useUserState();
	const userCanTrial = useFreeTrial();
	const pathname = usePathname();

	const purchaseBodyArgs = useMemo(
		() =>
			createPurchaseBodyArgs({
				purchaseParams,
				prices,
				user,
				userCanTrial,
				purchaseArgs: {
					isStripeNextEnrolled: true,
					isPartner: pathname?.includes('partnership'),
					...purchaseArgs,
					...(hasTrueMedSupport &&
						typeof process.env.NEXT_PUBLIC_TRUEMED_PUBLIC_QUALIFICATION_ID === 'string' &&
						typeof user?.id === 'string' && {
							trueMedLink: `https://app.truemed.com/qualify/${process.env.NEXT_PUBLIC_TRUEMED_PUBLIC_QUALIFICATION_ID}?user_id=${user.id}`,
						}),
				},
			}),
		[purchaseParams, prices, user, userCanTrial, purchaseArgs, hasTrueMedSupport, pathname],
	);

	return purchaseBodyArgs;
}
